module.exports = __webpack_public_path__ + "img/user-3.da1331da.jpg";